import axios from 'axios';

const API_BASE = '/api';

const getPassword = () => localStorage.getItem('admin_password') || '';

const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const password = getPassword();
  if (password) {
    config.headers['X-Admin-Password'] = password;
  }
  return config;
});

const isDev = process.env.NODE_ENV === 'development';

const fetchFromDbJson = async (field) => {
  const res = await axios.get(`${API_BASE}/db.json`);
  const data = res.data;
  if (data && Array.isArray(data[field])) return data[field];
  if (data && data[field] && !Array.isArray(data[field])) return Object.values(data[field]);
  return [];
};

const getCollection = async (endpoint, field) => {
  try {
    const r = await apiClient.get(endpoint);
    if (Array.isArray(r.data)) return r.data;
    // If backend returned something else (e.g. error page/string), try static db.json in dev
    if (isDev) return fetchFromDbJson(field);
    throw new Error(`Invalid response: expected array of ${field}`);
  } catch (e) {
    if (isDev) return fetchFromDbJson(field);
    throw e;
  }
};

export const getProducts = () => getCollection('/products.php', 'products');
export const getProduct = (id) => apiClient.get(`/products.php?id=${id}`).then(r => r.data);
export const createProduct = (data) => apiClient.post('/products.php', data).then(r => r.data);
export const updateProduct = (id, data) => apiClient.put(`/products.php?id=${id}`, data).then(r => r.data);
export const deleteProduct = (id) => apiClient.delete(`/products.php?id=${id}`).then(r => r.data);

export const getCategories = () => getCollection('/categories.php', 'categories');
export const getCategory = (id) => apiClient.get(`/categories.php?id=${id}`).then(r => r.data);
export const createCategory = (data) => apiClient.post('/categories.php', data).then(r => r.data);
export const updateCategory = (id, data) => apiClient.put(`/categories.php?id=${id}`, data).then(r => r.data);
export const deleteCategory = (id) => apiClient.delete(`/categories.php?id=${id}`).then(r => r.data);

export const uploadFile = (file, folder) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);
  return axios.post(`${API_BASE}/upload.php`, formData, {
    headers: {
      'X-Admin-Password': getPassword(),
      'Content-Type': 'multipart/form-data',
    },
  }).then(r => r.data);
};
